import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { Observable } from "rxjs";
import { ICustomerType } from "../../master-models/customer-type.model";

@Injectable()
export class CustomerTypesService {
  url = `${environment.apiBaseUrl}api/customer_types`;

  constructor(private http: HttpClient) {}

  getTypes(): Observable<{success: boolean, data: ICustomerType[]}> {
    return this.http.get<{success: boolean, data: ICustomerType[]}>(this.url, {
      headers: this.getHeaders(),
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/customer-types/customer-types.service.ts